function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Bell Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.9854,0.5 C8.26154237,0.5 8.4854,0.723857625 8.4854,1 L8.48608522,1.51737564 C11.5265992,1.73123586 13.5,3.9018585 13.5,7.064 L13.5,8.906 C13.5,10.9955728 13.8608862,12.7206989 14.4589676,14.1045098 C14.6654237,14.5821977 14.8851177,14.9821396 15.1028027,15.3068349 C15.2285928,15.4944614 15.321765,15.6115489 15.3669587,15.6603806 C15.663235,15.9805072 15.4361887,16.5 15,16.5 L10.4367328,16.5002611 C10.3805026,16.6679013 10.2831682,16.8453122 10.1305688,17.0182836 C9.71651144,17.4876173 9.01507469,17.75 7.99999904,17.75 C6.99868193,17.75 6.30109656,17.4877499 5.88315592,17.0210668 C5.72677672,16.8464498 5.62654542,16.6676776 5.56796944,16.5000184 L1,16.5 C0.563811273,16.5 0.336765023,15.9805072 0.633041289,15.6603806 C0.678234958,15.6115489 0.771407159,15.4944614 0.897197323,15.3068349 C1.11488228,14.9821396 1.33457628,14.5821977 1.54103243,14.1045098 C2.13911382,12.7206989 2.5,10.9955728 2.5,8.906 L2.5,7.064 C2.5,3.89671239 4.45181557,1.73077528 7.48483477,1.51734536 L7.4854,1 C7.4854,0.723857625 7.70925763,0.5 7.9854,0.5 Z M8.94318397,16.625 L7.06962149,16.625 C7.30037419,16.7040735 7.60545386,16.75 8,16.75 C8.40206763,16.75 8.71120599,16.7039238 8.94318397,16.625 Z M7.985,2.5 C5.22633815,2.5 3.5,4.27233384 3.5,7.064 L3.5,8.906 C3.5,11.1328022 3.11088618,12.9928636 2.45896757,14.5012402 C2.29107952,14.8896912 2.12174503,15.2221333 1.96051622,15.5 L14.0394838,15.5 C13.878255,15.2221333 13.7089205,14.8896912 13.5410324,14.5012402 C12.8891138,12.9928636 12.5,11.1328022 12.5,8.906 L12.5,7.064 C12.5,4.27966943 10.751707,2.5 7.985,2.5 Z",
  id: "bell-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "bell-Icon/Global/notifications",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bell-Swatches/DarkGreen",
  transform: "translate(4.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "bell-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#bell-path-1"
})));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.30b210c6.svg";
export { ForwardRef as ReactComponent };